const general = {
  specialOffers: 'Posebne Ponude',
  restaurantLabel: 'Doručak',
  readMore: 'Pročitajte više',
  rooms: 'Sobe',
  contactForm: {
    placeholder: 'Email Adresa',
    sendAction: 'Pošalji',
    sentLabel: 'Hvala',
    explanation: 'Želite da Vam šaljemo novosti i ponude ?',
  },
  info: {
    tel: '+382 67 051 736',
    address: 'Cara Dušana 2 85310 Budva Crna Gora',
    mail: 'office@lavillabudva.com',
  },
  booking: {
    arrival: 'Datum Dolaska',
    nights: 'Noćenja',
    check: 'Rezerviši',
    cancel: 'Promijeni/Otkaži Rezervaciju',
    code: 'Pristupni kod',
    optional: 'Opciono',
  },
};

export default general;